var _rect, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.72217,
    width: 19,
    height: 16.7778,
    rx: 1.5,
    stroke: "#01303D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8H20",
    stroke: "#01303D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83203 1C3.83203 0.723858 3.60817 0.5 3.33203 0.5C3.05589 0.5 2.83203 0.723857 2.83203 1L3.83203 1ZM2.83203 1L2.83203 3.22222L3.83203 3.22222L3.83203 1L2.83203 1Z",
    fill: "#01303D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.168 1C17.168 0.723858 16.9441 0.5 16.668 0.5C16.3918 0.5 16.168 0.723857 16.168 1L17.168 1ZM16.168 1L16.168 3.22222L17.168 3.22222L17.168 1L16.168 1Z",
    fill: "#01303D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.44314,
    cy: 12.1111,
    r: 1.11111,
    fill: "#01303D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.44314,
    cy: 16.5556,
    r: 1.11111,
    fill: "#01303D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0017,
    cy: 12.1111,
    r: 1.11111,
    fill: "#01303D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0017,
    cy: 16.5556,
    r: 1.11111,
    fill: "#01303D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5564,
    cy: 12.1111,
    r: 1.11111,
    fill: "#01303D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5564,
    cy: 16.5556,
    r: 1.11111,
    fill: "#01303D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDark);
export default __webpack_public_path__ + "static/media/calendar_dark.45dc5155032e7d1ff1d74e0a61df67c2.svg";
export { ForwardRef as ReactComponent };